// extracted by mini-css-extract-plugin
export default {"voucher":"CardCreated_voucher__BZYa5","small":"CardCreated_small__j-ttl"};